var React = require('react');

function PlusCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.5 1C17.2989 1 22 5.70114 22 11.5C22 17.2989 17.2989 22 11.5 22C5.70114 22 1 17.2989 1 11.5C1 5.70114 5.70114 1 11.5 1ZM5.55854 10.0001H10.0005V5.55854C10.0005 5.1469 10.3156 4.81064 10.701 4.81064H12.2995C12.6848 4.81064 12.9999 5.1469 12.9999 5.55854V10.0001H17.4413C17.8526 10.0001 18.1892 10.3152 18.1892 10.7005V12.299C18.1892 12.6846 17.8526 12.9995 17.4413 12.9995H12.9999V17.4411C12.9999 17.8524 12.6848 18.189 12.2995 18.189H10.701C10.3154 18.189 10.0005 17.8524 10.0005 17.4411V12.9995H5.55854C5.1469 12.9995 4.81064 12.6844 4.81064 12.299V10.7005C4.81064 10.3152 5.1469 10.0001 5.55854 10.0001Z","fill":"currentColor","stroke":"currentColor"}));
}

PlusCircle.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = PlusCircle;

PlusCircle.default = PlusCircle;
